// ts-gql-integrity:217e2a5e700e6d9ffa5e656d47aa8eb2
/*
ts-gql-meta-begin
{
  "hash": "c6eae28a28e1ced4d2b8f3bdb11074b3"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type IsClientIntegrationEnabledQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


type IsClientIntegrationEnabledQuery = { readonly __typename: 'Query', readonly isClientIntegrationEnabled: boolean | null };



export type type = TypedDocumentNode<{
  type: "query";
  result: IsClientIntegrationEnabledQuery;
  variables: {};
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    IsClientIntegrationEnabled: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"IsClientIntegrationEnabled\"},\"variableDefinitions\":[],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"isClientIntegrationEnabled\"},\"arguments\":[],\"directives\":[]}]}}]}")
